// Babel polyfill assures our site runs on old devices.
// This should always stay at the top.
import '@babel/polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { Router, browserHistory } from 'react-router';
import {
  compose,
  createStore,
  applyMiddleware,
  combineReducers,
} from 'redux';
import thunk from 'redux-thunk';
import AppContainer from 'components/application';

import AmazonAuthor from 'components/AmazonAuthor';
import { ADD_ERROR } from 'actions/shared';

/* Import any stores that you need to bootstrap,
otherwise they might not get included in the main Javascript
bundle and the store won't exist when you bootstrap. */
import './stores/I18nStore';

// Import routes
import landingPageRoutes from 'components/landing';
import termsRoutes from 'components/terms';
import helpRoutes from 'components/help';
import errorRoutes from 'components/error';
import notFoundRoutes from 'components/notFound';

import createReducer from 'stores/reducers/createReducer';
import { ErrorBoundary } from 'components/shared/ErrorBoundary';
import { getI18n, getWeblabs } from '../shared/selectors/bootstrapData';
import alt from './framework/alt';


// Bootstrap stores with data emitted by the Horizonte app into the DOM
const data = JSON.parse(document.getElementById('__data__').innerHTML);
const storeMapping = { i18n: 'I18nStore' };

Object.entries(data).forEach(([key, value]) => {
  alt.bootstrap(JSON.stringify({ [storeMapping[key]]: { [key]: value } }));
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const reduxStore = createStore(
  combineReducers({
    i18n: createReducer({}, {}),
    weblabs: createReducer({}, {}),
    errors: createReducer([], {
      [ADD_ERROR]: (state, { error }) => [...state, error],
    }),
  }),
  {
    i18n: getI18n(data),
    weblabs: getWeblabs(data),
  },
  composeEnhancers(applyMiddleware(thunk)),
);


const rootRoute = {
  component: props => <AppContainer store={reduxStore} {...props} />,
  childRoutes: [
    {
      path: '/',
      indexRoute: landingPageRoutes,
      component: AmazonAuthor,
      childRoutes: [
        landingPageRoutes,
        termsRoutes,
        helpRoutes,
        errorRoutes,
        notFoundRoutes, // This should always be last!
      ],
    },
  ],
};

const RouterWithErrorBoundary = () => (
  <ErrorBoundary>
    <Router history={browserHistory} routes={rootRoute} />
  </ErrorBoundary>
);

ReactDOM.render(
  React.createElement(RouterWithErrorBoundary),
  document.getElementById('amazon-author'),
);
